import { DestroyRef, Injectable, computed, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { fromEvent, merge } from 'rxjs';
import { App } from '@capacitor/app';
import { ConnectionStatus, Network } from '@capacitor/network';
import { PlatformService } from './platform.service';

@Injectable({ providedIn: 'root' })
export class AppConnectivityService {
  private readonly destroyRef = inject(DestroyRef);
  private readonly platform = inject(PlatformService);

  readonly status = signal<ConnectionStatus>({ connected: navigator.onLine, connectionType: 'unknown' });
  readonly isOnline = computed(() => this.status().connected);
  readonly connectionType = computed(() => this.status().connectionType);

  constructor() {
    void this.refresh();

    merge(fromEvent(window, 'online'), fromEvent(window, 'offline'))
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        void this.refresh();
      });

    if (this.platform.isNative()) {
      void Network.addListener('networkStatusChange', (status) => {
        this.status.set(status);
      });

      void App.addListener('resume', () => {
        void this.refresh();
      });
    }
  }

  async refresh(): Promise<void> {
    const networkStatus = await Network.getStatus();
    this.status.set(networkStatus);
  }
}
